<template>
  <g transform="matrix(1,0,0,1,0,0)">
    <path
      d="M 21.75,18.75h-10.5l-6,4.5v-4.5h-3c-0.828,0-1.5-0.672-1.5-1.5v-15c0-0.828,0.672-1.5,1.5-1.5h19.5 c0.828,0,1.5,0.672,1.5,1.5v15C23.25,18.078,22.578,18.75,21.75,18.75z "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 9.633,7.25C9.089,6.142,7.749,5.685,6.642,6.229 C6.198,6.447,5.839,6.806,5.621,7.25 "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 18.627,7.25c-0.544-1.108-1.884-1.565-2.991-1.021c-0.444,0.218-0.803,0.577-1.021,1.021 "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 8.252,12.75c2.194,2,5.55,2,7.744,0"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;
  
export default {
  name: "IconMessage",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {
  },
  computed: {
  }
};
</script>